import {ContinueComponent} from './questionnaire/continue/continue.component';
import {HelpComponent} from './main/help/help.component';
import {ResultComponent} from './questionnaire/result/result.component';
import {FinishedComponent} from './questionnaire/finished/finished.component';
import {IntroCheckComponent} from './intro/intro-check/intro-check.component';
import {ButtonsComponent} from './intro/buttons/buttons.component';
import {HowToComponent} from './intro/how-to/how-to.component';
import {ImprintComponent} from './main/imprint/imprint.component';
import {DataPolicyComponent} from './main/data-policy/data-policy.component';
import {LinksComponent} from './main/links/links.component';
import {HelpModalComponent} from './questionnaire/help-modal/help-modal.component';
import {QuestionComponent} from './questionnaire/question/question.component';
import {TippsComponent} from './intro/tipps/tipps.component';
import {AccessAuthorityComponent} from './intro/access-authority/access-authority.component';
import {IntroStartComponent} from './intro/intro-start/intro-start.component';
import {PopoverComponent} from './questionnaire/popover/popover.component';
import {StartComponent} from './questionnaire/start/start.component';
import {MenuComponent} from './main/menu/menu.component';
import {NavigationComponent} from './main/navigation/navigation.component';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy, PopoverController} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {IntroIndexComponent} from './intro/intro-index/intro-index.component';
import {CommonModule} from '@angular/common';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {LinkComponent} from './questionnaire/link/link.component';


@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    MenuComponent,
    StartComponent,
    PopoverComponent,
    IntroIndexComponent,
    IntroStartComponent,
    HowToComponent,
    AccessAuthorityComponent,
    TippsComponent,
    ButtonsComponent,
    QuestionComponent,
    HelpModalComponent,
    LinksComponent,
    DataPolicyComponent,
    ImprintComponent,
    IntroCheckComponent,
    FinishedComponent,
    ResultComponent,
    HelpComponent,
    ContinueComponent,
    LinkComponent
  ],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, CommonModule, ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    // Register the ServiceWorker as soon as the application is stable
    // or after 30 seconds (whichever comes first).
    registrationStrategy: 'registerWhenStable:30000'
  })],
  providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
